import {View} from 'react-native';

import sy from '~/styles';
import {PrivateText} from '~/components/controls';
import Format from '~/lib/format';
import PropTypes from 'prop-types';

const Avatar = ({first_name, last_name, size = 32}) => {
  const height = size;
  const width = size;

  const initials =
    (first_name?.charAt(0) ?? '') + (last_name?.split(' ')[0].charAt(0) ?? '');
  return (
    <View
      style={[
        sy['items-center'],
        sy['justify-center'],
        sy['bg-primary-brown'],
        sy['rounded-full'],
        {
          width,
          height,
        },
      ]}>
      <PrivateText
        style={[
          sy.uppercase,
          sy['text-white'],
          sy.mediumBold,
          {
            fontSize: Format.round(size / 2, 0),
            lineHeight: Format.round(size / 2, 0),
          },
        ]}>
        {initials.substring(0, 2)}
      </PrivateText>
    </View>
  );
};
Avatar.propTypes = {
  first_name: PropTypes.any,
  last_name: PropTypes.any,
  size: PropTypes.any,
};


export default Avatar;
